import * as React from 'react';
import { ApplicationContext } from '../common/contexts/ApplicationContext';
import { FeatureFlags } from '../constants/featureFlags';

/**
 * This is a convenience function to check the state of a given feature flag.
 * To avoid unnecessary re-renders of components, it is not advisable to use this
 * helper multiple times in a given component, instead it is preferred to get the list from
 * the application constant and check the list includes the desired flags, similar to how
 * it is done in this function.
 * @param featureFlag Flag to check state of
 */
export const useFeatureFlag: (featureFlag: FeatureFlags) => boolean = featureFlag => {
  const { featureFlags = [] } = React.useContext(ApplicationContext);

  return featureFlags.includes(featureFlag);
};
